<template>
    <div class="settings-container">
    <h2>Stripe API Settings</h2>
    <vs-input label="STRIPE_WEBHOOK_KEY" v-model="stripeKey" />
    <vs-button @click="updateStripeKey">Update Webhook Key</vs-button>
    <vs-input label="STRIPE_SECRET_KEY" v-model="stripeSecret" />
    <vs-button @click="updateStripeSecret">Update Secret</vs-button>
    <p style="color: red; margin-top: 10px;">
      Note: Updating these details will affect the live production application.
    </p>
  </div>
  </template>
  
  <script>
  import axios from 'axios';
  import {API} from '../../../common/constants';
  
  export default {
    data() {
      return {
        stripeKey: '',
        stripeSecret: ''
      };
    },
    methods: {
      fetchStripeKeys() {
        const user = JSON.parse(localStorage.getItem('user'));
        const token = user ? user.access_token : null;

        if (token) {
          const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: API.API_BASE+'/appConfig/fetchAllConfig',
            headers: { 
              'x-access-token': token
            }
          };
  
          axios.request(config)
            .then((response) => {
              // eslint-disable-next-line no-console
              const configData = response.data.data;
              // Find the relevant keys in the response data and populate the input fields
              this.stripeKey = (configData[0] && configData[0].value) || '';
              this.stripeSecret = (configData[1] && configData[1].value) || '';
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.error(error);
            });
        }
      },
      updateStripeKey() {
      const user = JSON.parse(localStorage.getItem('user'));
      const token = user ? user.access_token : null;

      if (token) {
        const data = JSON.stringify({
          "value": this.stripeKey
        });

        const config = {
          method: 'put',
          maxBodyLength: Infinity,
          url: API.API_BASE+`/appConfig/configUpdate/6527ddb8d270d58097c1abfd`, 
          headers: { 
            'x-access-token': token,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.makeApiCall(config);
      }
    },
    updateStripeSecret() {
      const user = JSON.parse(localStorage.getItem('user'));
      const token = user ? user.access_token : null;

      if (token) {
        const data = JSON.stringify({
          "value": this.stripeSecret
        });

        const config = {
          method: 'put',
          maxBodyLength: Infinity,
          url: API.API_BASE+`/appConfig/configUpdate/6527dde2d270d58097c1abff`, 
          headers: { 
            'x-access-token': token,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.makeApiCall(config);
      }
    },
    makeApiCall(config) {
      axios.request(config)
        .then((response) => {
          this.$vs.notify({
            text: "Record Updated",
            color: "success",
            position: "top-right",
          });
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          this.$vs.notify({
            text: "Failed to update record",
            color: "danger",
            position: "top-right",
          });
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  },
    created() {
      // Fetch the Stripe keys when the component is created
      this.fetchStripeKeys();
    }
  };
  </script>
  
  <style scoped>
  .settings-container {
    margin: 0 auto;
    max-width: 50%;
    padding: 20px;
  }
  </style>
  